import React, { useContext }  from 'react';
import { ThemeContext } from 'styled-components'
import styled from 'styled-components'
import Contact from './components/contact'
import FAQ from './components/faq'
const Page = styled.div`
`;

const Content = styled.div`
  margin: 0 auto;
  max-width: 1200px;
  padding: 32px 16px;

  @media(max-width: 900px) {
    padding: 16px 8px;
  }
`;

const MarginSpacer = styled.div`
  height: 32px;
`

const Dashboard = () => {
  const theme = useContext(ThemeContext)

  return (
    <Page>
      <Content>
        {theme.name === 'AVATAR' && <FAQ />}
        <MarginSpacer />
        <Contact />
      </Content>
    </Page>
  )
}

export default Dashboard